
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XHeader from 'vux/src/components/x-header/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Popup from 'vux/src/components/popup/index.vue'
import Swipeout from 'vux/src/components/swipeout/swipeout.vue'
import SwipeoutItem from 'vux/src/components/swipeout/swipeout-item.vue'
import SwipeoutButton from 'vux/src/components/swipeout/swipeout-button.vue'
import XAddress from 'vux/src/components/x-address/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XSwitch from 'vux/src/components/x-switch/index.vue'
import Group from 'vux/src/components/group/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
components: {
XTextarea,
TransferDom,
XHeader,
XButton,
Popup,
Swipeout, SwipeoutItem, SwipeoutButton,
XAddress,
XInput,
XSwitch,
Group
},
data() {
return {
limitNumber: 6,
action: 'add',
bankCardList: [],

showEditbankCard: false,
formbankCard: this.formbankCardInitData(),
bankCardData: [],
}
},
created: function () {
document.title = '银行卡列表'
this.handlebankCardList()
},
methods: {

formbankCardInitData() {
return {
holder_name: '',
holder_mobile: '',
bank_id: '',
card_no: ''
}
},
handlebankCardList() {
this.$vux.loading.show({
text: '加载中'
})
const url = this.tianYiWebUrl + '/wechat/bankcard/lists'
this.$http.get(url).then(v => {
this.bankCardList = v.data.data
console.log(this.bankCardList)
this.$vux.loading.hide()
})
},

addbankCard() {
this.action = 'add'

this.formbankCard = this.formbankCardInitData();
this.showEditbankCard = true;
},
postbankCard() {
this.$vux.loading.show({
text: '处理中'
})
const url = this.tianYiWebUrl + '/wechat/bankCard/ajaxPostbankCard';
this.$http.post(url, this.formbankCard).then(r => {

let type = 'cancel'

if (r.data.code === 200) {
if (this.action === 'add') {
this.bankCardList = [...this.bankCardList, r.data.data]
this.formbankCard = this.formbankCardInitData();
}
if (this.action === 'edit') {
this.bankCardList[this.actionIndex] = r.data.data
}
this.showEditbankCard = false

type = 'success'
}
this.$vux.toast.show({
text: r.data.message,
type: type
})
this.$vux.loading.hide()
})
},

onButtonClick(action, item, index) {
if (action === 'edit') {
this.action = 'edit'
this.actionIndex = index
this.formbankCard = item;
this.showEditbankCard = true
}
if (action === 'delete') {
var _self = this;
this.$vux.confirm.show({
title: '是否删除此银行卡号',
onShow() {
},
onHide() {
},
onCancel() {
},
onConfirm() {

_self.$vux.loading.show({
text: '处理中'
});

const url = _self.tianYiWebUrl + '/wechat/bankCard/delBankCard';
_self.$http.post(url, {id: item['id']}).then(r => {
_self.bankCardList.splice(index, 1);


_self.$vux.loading.hide()
})
}
});
}
},
}
}



// WEBPACK FOOTER //
// ./src/components/uc/BankCard.vue